"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueValueByTiffMappingRaster = void 0;
const raster_1 = require("./raster");
const raster_generator_1 = require("./raster-generator");
const helpers_1 = require("./helpers");
/**
 * Buckets is formed by using uniques values in the data
 */
class UniqueValueByTiffMappingRaster extends raster_1.Raster {
    constructor(data, bounds, colorRange, tiffMapping, options) {
        super(data, bounds, colorRange, options);
        this.tiffMapping = tiffMapping;
        // Pixels with 0 value is transparent
        this.noDataValues = [0];
        // Use keyed index function to find the color for the value
        this.colorIndexFnType = raster_1.ColorIndexFnType.KEYED;
        this.ranges = this.computeRanges();
        this.imageData = this.computeImagedata();
    }
    computeRanges() {
        switch (this.options.sortOption) {
            case raster_generator_1.RasterSortOption.AREA:
                return (0, helpers_1.getUniqueValuesSortedByArea)(this.orderedValues);
            default:
                return (0, helpers_1.getUniqueValuesFromTiffMapping)(this.tiffMapping);
        }
    }
}
exports.UniqueValueByTiffMappingRaster = UniqueValueByTiffMappingRaster;
